/**
 * Markdown 预处理器集合
 *
 * 独立的纯函数，用于在 Markdown 渲染前进行各种语法转换
 */

/**
 * 预处理 AI 聊天块语法
 * 将 :::ai-chat ... :::end 转换为标准 :::ai-chat ... :::
 *
 * @example
 * ```ts
 * const input = ":::ai-chat\n[goal] xxx\n:::end"
 * const output = preprocessAiChatSyntax(input)
 * // => ":::ai-chat\n[goal] xxx\n:::"
 * ```
 */
export function preprocessAiChatSyntax(markdown: string): string {
  return markdown.replace(
    /:::ai-chat\s*\n([\s\S]*?)\n:::end/g,
    (_, content) => `:::ai-chat\n${content}\n:::`
  )
}

/**
 * 预处理课程 Markdown 内容
 * 组合所有预处理器，按顺序执行
 *
 * @param rawMarkdown - 原始 Markdown 内容
 * @returns 处理后的 Markdown 内容
 */
export function preprocessLessonMarkdown(rawMarkdown: string): string {
  let processed = rawMarkdown

  // 依次应用各个预处理器
  processed = preprocessAiChatSyntax(processed)

  // 未来可以在这里添加更多预处理器
  // processed = preprocessXXX(processed)

  return processed
}
